import React from 'react'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import HeaderMedia from '../ui/headerMedia'
import Logo from '../ui/logo'

type ToolHeaderProps = {
  name: string
  logo: string | null
  header: string | IGatsbyImageData | null
}

export const ToolHeader: React.FC<ToolHeaderProps> = ({ name, logo, header }) => (
  <div data-testid="tool-header" className="container mb-8 lg:mb-16">
    <div className="relative">
      <HeaderMedia headerMediaImage={header} tool />
    </div>
    <div
      className="absolute top-[200px] lg:top-[320px] inset-x-0 text-center text-white w-screen xl:w-[1115px] lg:w-[950px] lg:mx-auto 2xl:w-[1300px]"
    >
      <div className="flex flex-col items-center gap-8 lg:flex-row lg:gap-0">
        <div
          className="shadow w-24 h-24 bg-white rounded-xl p-6 flex items-center justify-center lg:top-[25px] lg:w-[130px] lg:h-[130px]"
        >
          <Logo image={logo} alt={name} />
        </div>
        <h1 className="mx-12 text-4xl font-semibold lg:mx-4">{name}</h1>
      </div>
    </div>
  </div>
)
